define("shared/components/shared/loading-cards", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/template-only",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    role="progressbar"
    aria-valuetext={{t "shared_words.loading"}}
    aria-busy="true"
    class="o--cardContainer cCS--cardContainer {{if @isHorizontalCard "cCS--cardContainer--horizontal"}}"
    data-test-id="loading-card"
    ...attributes
  >
    {{#if @isHorizontalCard}}
      <div class="cCS--cardLoad o--card">
        <div class="cCS--cardLoad__effect">
          <div class="cCS--cardLoad__mask cCS--cardLoad__mask--9"></div>
          <div class="cCS--cardLoad__mask cCS--cardLoad__mask--10"></div>
          <div class="cCS--cardLoad__mask cCS--cardLoad__mask--11"></div>
          <div class="cCS--cardLoad__mask cCS--cardLoad__mask--12"></div>
          <div class="cCS--cardLoad__mask cCS--cardLoad__mask--13"></div>
          <div class="cCS--cardLoad__mask cCS--cardLoad__mask--14"></div>
          <div class="cCS--cardLoad__mask cCS--cardLoad__mask--15"></div>
          <div class="cCS--cardLoad__mask cCS--cardLoad__mask--16"></div>
        </div>
      </div>
    {{else if @isSquareCard}}
      <div class="cCS--cardLoad o--card">
        <div class="cCS--cardLoad__effect">
          <div class="cCS--cardLoad__mask cCS--cardLoad__mask--square"></div>
        </div>
      </div>
    {{else}}
      <div class="cCS--cardLoad o--card">
        <div class="cCS--cardLoad__effect">
          <div class="cCS--cardLoad__mask cCS--cardLoad__mask--1"></div>
          <div class="cCS--cardLoad__mask cCS--cardLoad__mask--2"></div>
          <div class="cCS--cardLoad__mask cCS--cardLoad__mask--3"></div>
          <div class="cCS--cardLoad__mask cCS--cardLoad__mask--4"></div>
          <div class="cCS--cardLoad__mask cCS--cardLoad__mask--5"></div>
          <div class="cCS--cardLoad__mask cCS--cardLoad__mask--6"></div>
          <div class="cCS--cardLoad__mask cCS--cardLoad__mask--7"></div>
          <div class="cCS--cardLoad__mask cCS--cardLoad__mask--8"></div>
        </div>
      </div>
    {{/if}}
  </div>
  
  */
  {
    "id": "qv9mm5tr",
    "block": "[[[11,0],[24,\"role\",\"progressbar\"],[16,\"aria-valuetext\",[28,[37,0],[\"shared_words.loading\"],null]],[24,\"aria-busy\",\"true\"],[16,0,[29,[\"o--cardContainer cCS--cardContainer \",[52,[30,1],\"cCS--cardContainer--horizontal\"]]]],[24,\"data-test-id\",\"loading-card\"],[17,2],[12],[1,\"\\n\"],[41,[30,1],[[[1,\"    \"],[10,0],[14,0,\"cCS--cardLoad o--card\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"cCS--cardLoad__effect\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"cCS--cardLoad__mask cCS--cardLoad__mask--9\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"cCS--cardLoad__mask cCS--cardLoad__mask--10\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"cCS--cardLoad__mask cCS--cardLoad__mask--11\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"cCS--cardLoad__mask cCS--cardLoad__mask--12\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"cCS--cardLoad__mask cCS--cardLoad__mask--13\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"cCS--cardLoad__mask cCS--cardLoad__mask--14\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"cCS--cardLoad__mask cCS--cardLoad__mask--15\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"cCS--cardLoad__mask cCS--cardLoad__mask--16\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[41,[30,3],[[[1,\"    \"],[10,0],[14,0,\"cCS--cardLoad o--card\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"cCS--cardLoad__effect\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"cCS--cardLoad__mask cCS--cardLoad__mask--square\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,0],[14,0,\"cCS--cardLoad o--card\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"cCS--cardLoad__effect\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"cCS--cardLoad__mask cCS--cardLoad__mask--1\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"cCS--cardLoad__mask cCS--cardLoad__mask--2\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"cCS--cardLoad__mask cCS--cardLoad__mask--3\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"cCS--cardLoad__mask cCS--cardLoad__mask--4\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"cCS--cardLoad__mask cCS--cardLoad__mask--5\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"cCS--cardLoad__mask cCS--cardLoad__mask--6\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"cCS--cardLoad__mask cCS--cardLoad__mask--7\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"cCS--cardLoad__mask cCS--cardLoad__mask--8\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]]]],[]]],[13],[1,\"\\n\"]],[\"@isHorizontalCard\",\"&attrs\",\"@isSquareCard\"],false,[\"t\",\"if\"]]",
    "moduleName": "shared/components/shared/loading-cards.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});